import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

/**
 * Base API slice for the application
 *
 * This is the single base API slice that all other endpoints should inject into
 * using the injectEndpoints pattern for code splitting and better organization.
 *
 * Tag types should be added dynamically using enhanceEndpoints({ addTagTypes: [...] })
 * when injecting endpoints in feature-specific files.
 *
 * @see https://redux-toolkit.js.org/rtk-query/usage/code-splitting
 */
export const api = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({ baseUrl: '/' }),
  tagTypes: [],
  endpoints: () => ({}),
})
